<template>
  <div class="monster-query-content">
    <!-- 搜索区域 -->
    <div class="search-section">
      <div class="layui-form-item">
        <div class="layui-input-wrap">
          <div class="layui-input-prefix">
            <i class="layui-icon layui-icon-search"></i>
          </div>
          <input
              type="text"
              v-model="searchQuery"
              placeholder="输入怪物名称..."
              class="layui-input"
              lay-affix="clear"
          >
        </div>
      </div>
    </div>

    <!-- 内容容器：横向排列4个列表区域 -->
    <div class="data-container">
      <!-- 1. 怪物列表区域 -->
      <div class="monster-list-section">
        <div class="section-header">
          <span>
            双击
            <span class="highlight-text"> 怪物名称 </span>弹出详细爆率信息
          </span>
        </div>
        <div class="section-content">
          <div class="monster-list" v-if="filteredMonsters.length">
            <div
                v-for="(monster, index) in filteredMonsters"
                :key="`monster-${monster[1]}-${index}`"
                @click="selectMonster(monster)"
                @dblclick="openDropRateModal(monster)"
                @touchstart="handleTouchStart($event, monster)"
                @touchend="handleTouchEnd($event, monster)"
                @touchmove="handleTouchMove"
                :class="{ active: selectedMonster && selectedMonster[1] === monster[1] }"
            >
              <span style="color:red;">{{index+1}}.</span>{{ monster[0] }}
            </div>
          </div>
          <div class="empty-state" v-else>
            <i class="fas fa-ghost"></i>
            <p>暂无怪物数据</p>
          </div>
        </div>
      </div>

      <!-- 2. 掉落物品区域 -->
      <div class="monster-list-section">
        <div class="section-header">
          <div v-if="!selectedMonster">掉落物品</div>
          <div v-else>
            正在查询
            <span class="highlight-text">{{ selectedMonster[0] }}</span>
            的产出
          </div>
        </div>
        <div class="section-content">
          <div class="monster-list" v-if="droppedItems.length">
            <div
                v-for="(item, index) in droppedItems"
                :key="`drop-item-${item[1]}-${index}`"
                @click="selectItem(item)"
                :class="{
                active: selectedItem && selectedItem[1] === item[1],
                'item-list-item': true
              }"
            >
              <span>{{index+1}}.</span>{{ item[0] }}
            </div>
          </div>
          <div class="empty-state" v-else>
            <i class="layui-icon layui-icon-tips"></i>
            <p v-if="selectedMonster">该怪物没有掉落物品数据</p>
            <p v-else>请先选择一个怪物</p>
          </div>
        </div>
      </div>

      <!-- 3. 刷新地图区域 -->
      <div class="monster-list-section">
        <div class="section-header">
          <div v-if="!selectedMonster">刷新地图</div>
          <div v-else>
            正在查询<span class="highlight-text">{{ selectedMonster[0] }}</span>
            的刷新地
          </div>
        </div>
        <div class="section-content">
          <div class="map-list" v-if="refreshMaps.length">
            <div
                v-for="(map, index) in refreshMaps"
                :key="`refresh-map-${map.id}-${index}`"
                @click="selectMap(map)"
            >
              <span style="margin-left:10px;">{{index+1}}.</span>
              <span style="margin-left:5px;">{{ map.name }} - 共</span>
              <span style="color:#67c23a;">{{ map.mongencount }}</span>&nbsp;只&nbsp;-&nbsp;刷新时间&nbsp;
              <span style="color:red;">{{ map.refreshRate }}</span>分钟
            </div>
          </div>
          <div class="empty-state" v-else>
            <i class="layui-icon layui-icon-tips"></i>
            <p v-if="selectedMonster">该怪物没有刷新地图数据</p>
            <p v-else>请先选择一个怪物</p>
          </div>
        </div>
      </div>

      <!-- 4. 地图走法区域 -->
      <div class="monster-list-section">
        <div class="section-header">
          <div v-if="!selectedMap">地图走法</div>
          <div v-else>
            正在查询<span class="highlight-text">{{ selectedMap.name }}</span>
            的走法
          </div>
        </div>
        <div class="section-content">
          <div v-if="mapPaths.length">
            <div
                v-for="(pathGroup, index) in mapPaths"
                :key="`path-group-${index}`"
                class="path-group"
            >
              <div class="path-header">
                第{{ index + 1 }}种走法
              </div>
              <div
                  v-for="(path, pIndex) in pathGroup"
                  :key="`path-${path.from}-${pIndex}`"
                  class="path-item"
              >
                <p>{{pIndex+1}}. 从 <span style="color:red;">{{ path.fromName }}</span> 地图 坐标 <span style="color:red;">{{ path.fromKey }}</span> NPC进入<span style="color:red;">{{ path.toName }}</span></p>
              </div>
            </div>
          </div>
          <div class="empty-state" v-else>
            <i class="layui-icon layui-icon-tips"></i>
            <p v-if="selectedMap">该地图没有路径数据</p>
            <p v-else>请先选择一个地图</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 爆率弹窗 -->
    <div class="drop-rate-modal" v-if="isModalOpen">
      <div class="modal-overlay" @click="closeDropRateModal"></div>
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">
            <span style="color:red;">{{ currentMonster?.[0] || '怪物' }}</span> 掉落爆率详情
          </h3>
        </div>
        <div class="modal-body">
          <div class="modal-empty" v-if="!currentDropRates.length">
            <i class="fas fa-box-open"></i>
            <p>该怪物暂无掉落物品数据</p>
          </div>
          <table class="drop-rate-table" v-else>
            <thead>
            <tr>
              <th>序号</th>
              <th style="text-align:center;">物品名称</th>
              <th style="text-align:right;">爆率等级</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in currentDropRates" :key="`modal-item-${item.id}-${index}`">
              <td class="table-index">{{ index + 1 }}</td>
              <td class="table-item-name"  style="text-align:center;">{{ item.name }}</td>
              <td style="text-align:right;">
                    <span class="drop-rate-badge" :class="`drop-rate-${item.dropRateLevel}`">
                      {{ item.dropRateDesc }}
                    </span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button class="modal-close-btn" @click="closeDropRateModal">
            关闭
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue';

export default {
  components: {},
  props: {
    monsterData: { type: Array, required: true, default: () => [] },
    mapData: { type: Array, required: true, default: () => [] },
    monsterRefresh: { type: Array, required: true, default: () => [] },
    stditemsData: { type: Array, required: true, default: () => [] }
  },
  setup(props) {
    // 原有状态管理
    const searchQuery = ref('');
    const selectedMonster = ref(null);
    const selectedMap = ref(null);
    // 新增：掉落物品选中状态（和selectedMonster对应，记录选中的物品）
    const selectedItem = ref(null);

    // 新增：弹窗相关状态
    const isModalOpen = ref(false);
    const currentMonster = ref(null);
    const currentDropRates = ref([]);

    // 新增：双击触摸事件相关状态
    const touchState = ref({
      startTime: 0,
      startX: 0,
      startY: 0,
      isDoubleTap: false,
      activeMonster: null,
      threshold: 300, // 双击时间间隔阈值(ms)
      distance: 10    // 双击位置偏差阈值(px)
    });

    // 掉落率区间规则
    const dropRateRules = [
      { min: 1, max: 299, desc: '很高', level: 'very-high' },
      { min: 300, max: 799, desc: '高', level: 'high' },
      { min: 800, max: 1599, desc: '较高', level: 'medium-high' },
      { min: 1600, max: 2999, desc: '适合', level: 'suitable' },
      { min: 3000, max: 4999, desc: '一般', level: 'normal' },
      { min: 5000, max: 7999, desc: '有点低', level: 'low-medium' },
      { min: 8000, max: Infinity, desc: '低', level: 'low' }
    ];

    // 原有计算属性
    const filteredMonsters = computed(() => {
      if (!searchQuery.value) return props.monsterData;
      return props.monsterData.filter(monster =>
          monster[0].toLowerCase().includes(searchQuery.value.toLowerCase())
      );
    });

    const droppedItems = computed(() => {
      if (!selectedMonster.value) return [];

      const monsterId = Number(selectedMonster.value[1]);
      const itemIds = new Set();

      props.monsterRefresh.forEach(refresh => {
        if (Number(refresh.c_mongen_id) === monsterId && refresh.c_goods && Array.isArray(refresh.c_goods)) {
          refresh.c_goods.forEach(goods => {
            itemIds.add(Number(goods[1]));
          });
        }
      });

      return props.stditemsData.filter(item =>
          itemIds.has(Number(item[1]))
      );
    });

    const refreshMaps = computed(() => {
      if (!selectedMonster.value) return [];
      const monsterId = Number(selectedMonster.value[1]);
      const maps = [];
      const mapCodeSet = new Set();

      props.monsterRefresh.forEach(refresh => {
        if (Number(refresh.c_mongen_id) === monsterId && refresh.c_refresh && Array.isArray(refresh.c_refresh)) {
          refresh.c_refresh.forEach(refreshInfo => {
            const mapCode = String(refreshInfo[0]).toLowerCase();
            const refreshTime = refreshInfo[2] || '未知';
            const mongencount = refreshInfo[1] || '未知';

            if (mapCodeSet.has(mapCode)) return;
            mapCodeSet.add(mapCode);

            const mapInfo = props.mapData.find(map => String(map[1]).toLowerCase() === mapCode);
            if (mapInfo) {
              maps.push({
                id: mapCode,
                name: mapInfo[0],
                refreshRate: refreshTime,
                mongencount: mongencount
              });
            }
          });
        }
      });
      return maps;
    });

    const mapPaths = computed(() => {
      if (!selectedMap.value) return [];
      const mapCode = String(selectedMap.value.id).toLowerCase();
      const pathGroups = [];

      props.mapData.forEach(map => {
        if (String(map[1]).toLowerCase() === mapCode && map[2] && Array.isArray(map[2])) {
          map[2].forEach(pathGroup => {
            const groupPaths = [];
            if (!Array.isArray(pathGroup)) return;

            pathGroup.forEach(path => {
              if (path.from && path.to) {
                const fromCode = String(path.from).toLowerCase();
                const toCode = String(path.to).toLowerCase();
                const fromMap = props.mapData.find(m => String(m[1]).toLowerCase() === fromCode);
                const toMap = props.mapData.find(m => String(m[1]).toLowerCase() === toCode);

                if (fromMap && toMap) {
                  groupPaths.push({
                    from: path.from,
                    fromName: fromMap[0],
                    fromKey: path.fromkey || '未知',
                    to: path.to,
                    toName: toMap[0],
                    toKey: path.tokey || '未知'
                  });
                }
              }
            });
            if (groupPaths.length) pathGroups.push(groupPaths);
          });
        }
      });
      return pathGroups;
    });
    // 新增：选中物品的方法（和selectMonster对应）
    const selectItem = (item) => {
      selectedItem.value = item; // 记录当前选中的物品
      // 可选：如果需要点击物品时取消地图选中，可加上这句
      // selectedMap.value = null;
    };
    // 新增：触摸事件处理函数
    const handleTouchStart = (e, monster) => {
      // 只处理单指触摸
      if (e.touches.length !== 1) return;

      const touch = e.touches[0];
      const now = Date.now();

      // 检查是否在双击时间窗口内
      if (now - touchState.value.startTime < touchState.value.threshold) {
        // 计算触摸位置偏差
        const dx = Math.abs(touch.clientX - touchState.value.startX);
        const dy = Math.abs(touch.clientY - touchState.value.startY);

        // 如果是同一怪物且位置偏差在阈值内，视为双击
        if (
            dx < touchState.value.distance &&
            dy < touchState.value.distance &&
            touchState.value.activeMonster &&
            touchState.value.activeMonster[1] === monster[1]
        ) {
          touchState.value.isDoubleTap = true;
          e.preventDefault(); // 阻止后续事件
        }
      }

      // 更新触摸状态
      touchState.value.startTime = now;
      touchState.value.startX = touch.clientX;
      touchState.value.startY = touch.clientY;
      touchState.value.activeMonster = monster;
    };

    const handleTouchEnd = (e, monster) => {
      // 如果检测到双击，打开爆率弹窗
      if (touchState.value.isDoubleTap &&
          touchState.value.activeMonster &&
          touchState.value.activeMonster[1] === monster[1]) {
        openDropRateModal(monster);
        touchState.value.isDoubleTap = false; // 重置状态
        e.preventDefault();
      }
    };

    const handleTouchMove = (e) => {
      // 如果触摸移动距离过大，取消双击检测
      if (touchState.value.startTime) {
        const touch = e.touches[0];
        const dx = Math.abs(touch.clientX - touchState.value.startX);
        const dy = Math.abs(touch.clientY - touchState.value.startY);

        if (dx > touchState.value.distance || dy > touchState.value.distance) {
          touchState.value.startTime = 0; // 重置触摸状态
        }
      }
    };

    // 弹窗控制方法
    const openDropRateModal = (monster) => {
      currentMonster.value = monster;
      const monsterId = Number(monster[1]);
      const dropRates = [];

      props.monsterRefresh.forEach(refresh => {
        if (Number(refresh.c_mongen_id) === monsterId && refresh.c_goods && Array.isArray(refresh.c_goods)) {
          refresh.c_goods.forEach(goods => {
            const [dropRate, itemId] = goods;
            const targetItemId = Number(itemId);
            const matchedItem = props.stditemsData.find(item => Number(item[1]) === targetItemId);

            if (matchedItem) {
              const matchedRule = dropRateRules.find(rule => dropRate >= rule.min && dropRate <= rule.max) || dropRateRules[6];
              dropRates.push({
                id: targetItemId,
                name: matchedItem[0],
                dropRate: dropRate || 0,
                dropRateDesc: matchedRule.desc,
                dropRateLevel: matchedRule.level
              });
            }
          });
        }
      });

      currentDropRates.value = dropRates;
      isModalOpen.value = true;
      document.body.style.overflow = 'hidden';
    };

    const closeDropRateModal = () => {
      isModalOpen.value = false;
      document.body.style.overflow = 'auto';
    };

    // 原有选择方法
    const selectMonster = (monster) => {
      selectedMonster.value = monster;
      selectedMap.value = null;
      // 新增：切换怪物时，清空物品选中状态（避免跨怪物保留选中）
      selectedItem.value = null;
    };

    const selectMap = (map) => {
      selectedMap.value = map;
    };

    return {
      // 原有返回值
      searchQuery,
      selectedMonster,
      selectedMap,
      filteredMonsters,
      droppedItems,
      refreshMaps,
      mapPaths,
      selectMonster,
      selectMap,
      // 新增弹窗相关
      isModalOpen,
      currentMonster,
      currentDropRates,
      openDropRateModal,
      closeDropRateModal,
      // 新增触摸事件处理
      handleTouchStart,
      handleTouchEnd,
      handleTouchMove,
      // 新增：物品选中相关
      selectedItem, // 暴露选中物品状态
      selectItem    // 暴露选中物品方法
    };
  }
};
</script>

<style>
/* 新增：弹窗样式 */
.drop-rate-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(2px);
}

.modal-content {
  position: relative;
  width: 90%;
  max-width: 500px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 20px;
  border-bottom: 1px solid #e6e6e6;
}
.drop-rate-table thead tr th{
  line-height:0px;
}
.drop-rate-table tr {
  line-height: 2px; /* 设置行高 */
}
.modal-title {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
}

.modal-close {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #999;
  padding: 4px;
  border-radius: 50%;
}

.modal-close:hover {
  color: #333;
  background-color: #f5f5f5;
}

.modal-body {
  max-height: 500px;
  overflow-y: auto;
  padding: 20px;
}

.modal-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #999;
}

.modal-empty i {
  font-size: 64px;
  margin-bottom: 20px;
  opacity: 0.5;
}

.drop-rate-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}

.drop-rate-table th,
.drop-rate-table td {
  padding: 12px 16px;
  border-bottom: 1px solid #e6e6e6;
}

.drop-rate-table th {
  background-color: #f5f5f5;
  font-weight: 500;
}

.table-index {
  width: 60px;
  text-align: center;
}

.table-item-name {
  width: 63%;
}

.table-rate-value {
  color: #666;
  font-family: monospace;
}

.modal-footer {
  padding: 16px 20px;
  border-top: 1px solid #e6e6e6;
  display: flex;
  justify-content: flex-end;
}
.drop-rate-badge {
  margin-left:0px;
}

.modal-close-btn {
  padding: 8px 16px;
  background-color: #1890ff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.modal-close-btn:hover {
  background-color: #096dd9;
}

::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #aaa;
}
/* 怪物查询组件独立样式表 */
/* 1. 基础容器样式 */
.monster-query-content {
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  margin: 0;
  position: relative;
  height: calc(100vh - 100px);
}


/* 2. 搜索区域 */
.search-section {
  background: white;
  border-radius: 4px;
  margin-bottom: 15px;
  width:33%;
}

.search-section .layui-form-item {
  margin: 0;
}

.search-section .layui-input {
  border-radius: 4px;
  padding-left: 30px !important;
  height: 30px;
  border: 1px solid #e6e6e6;
}

.search-section .layui-input-prefix {
  color: #888;
  line-height: 30px;
}
/* 3. 内容容器样式 */
.data-container {
  display: flex;
  gap: 15px;
  overflow-x: auto;
  padding-bottom: 8px;
  scrollbar-width: none;
  height: calc(100vh - 137px) !important;
}

.data-container::-webkit-scrollbar {
  display: none;
}

/* 4. 列表区域样式（替代DataBox） */
.monster-list-section {
  flex: 0 0 320px;
  display: flex;
  flex-direction: column;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  overflow: hidden;
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  height: 100%;
}

/* 5. 列表标题栏样式 */
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #e6e6e6;
  height: 42px;
  box-sizing: border-box;
}

.section-header div {
  margin:0 auto;
  text-align:center;
}

.highlight-text {
  color: #409eff;
  font-weight: 600;
  margin:0 !important;
}

.section-header .badge {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 12px;
  background-color: #e3f2fd;
  color: #1565c0;
}

/* 6. 列表内容区域样式 */
.section-content {
  flex: 1;
  padding: 0 !important;
  box-sizing: border-box;
  overflow-y: auto;
  scrollbar-width: none;
  scrollbar-color: rgba(156, 156, 156, 0.6) transparent;
  transition: scrollbar-width 0.3s ease;
}

.section-content::-webkit-scrollbar {
  width: 0;
  transition: width 0.3s ease-in-out;
}

.section-content:hover::-webkit-scrollbar {
  width: 2px;
}

.section-content::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 10px;
}

.section-content::-webkit-scrollbar-thumb {
  background-color: rgba(156, 156, 156, 0.6);
  border-radius: 10px;
}

.section-content:hover {
  scrollbar-width: thin;
}

/* 7. 列表项样式 */
.monster-list, .item-list, .map-list {
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
}

.monster-list div, .item-list div, .map-list div {
  border-bottom: 1px solid #eee;
  cursor: pointer;
  transition: background-color 0.2s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
  height:31px;
}

.monster-list span{
  margin-left:10px;
}

.monster-list div:hover, .item-list div:hover, .map-list div:hover {
  background-color: #409eff;
}

.monster-list div.active {
  background-color: #409eff;
  color: white;
  font-weight: bold;
}

/* 8. 徽章样式 */

/* 9. 空状态样式 */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #999;
  gap: 10px;
}

.empty-state i {
  font-size: 48px;
  opacity: 0.5;
}

.empty-state p {
  margin: 0;
  font-size: 14px;
}

/* 10. 路径走法样式 */
.path-group {
  margin-bottom: 15px;
  border: 1px solid #eee;
  border-radius: 4px;
  overflow: hidden;
}

.path-header {
  padding: 8px 12px;
  background-color: #f5f5f5;
  font-weight: 600;
  font-size: 14px;
  color: #333;
  border-bottom: 1px solid #eee;
}

.path-item {
  border-bottom: 1px solid #eee;
  background: #f9f9f9;
}

.path-item:last-child {
  border-bottom: none;
}

.section-title {
  font-weight: 500;
  margin-bottom: 4px;
  color: #333;
  display: flex;
  align-items: center;
  gap: 6px;
}

.section-title i {
  color: #1890ff;
}

.path-item p {
  margin: 0 0 8px 0;
  font-size: 13px;
  color: #666;
}

.path-item p:last-child {
  margin-bottom: 0;
}

/* 11. 响应式样式 */
/*
@media (max-width: 1600px) {
  .search-section .layui-input {
    border-radius: 4px;
    padding-left: 30px !important;
    height: 30px;
    border: 1px solid #e6e6e6;
    width:100%;
  }
  .monster-list-section {
    flex: 0 0 129px;
  }
}

@media (max-width: 1200px) {
  .data-container {
    flex-wrap: wrap;
    height: auto;
     height: calc(100vh - 100px);
  }

  .monster-list-section {
    flex: 0 0 calc(50% - 10px);
  }
}*/

@media (max-width: 768px) {
  .query-container {
    grid-template-columns: 1fr;
  }
  .search-section{
    width:100%;
  }

  .data-container {
    flex-direction: column;
    flex-wrap: nowrap;
  }

  .monster-list-section {

    width: 100%;
  }
}

</style>